<script setup lang="ts">
import { computed, ref, watch } from "vue"
import { useI18n } from "vue-i18n"

import qualityService from "@/services/quality"
import type { Product } from "@/types/product.type"
import { reportSentry } from "@/utils/sentry"

const { t } = useI18n()

const { product, isForPurchase, modalOpen } = defineProps({
  product: { type: Object, required: true },
  isForPurchase: { type: Boolean, default: true },
  modalOpen: { type: Boolean, default: false },
})

const prevProduct = ref<Product | null>(null)
const nextProduct = ref<Product | null>(null)

const needProducts = computed(() => isForPurchase && !product.quality.storeCoded)

watch(
  () => modalOpen,
  async (opened) => {
    if (opened && needProducts.value) {
      try {
        const data = await qualityService.products(product.quality.id)
        const products = data.products

        prevProduct.value = products.find((p) => p.colorNumber === product.colorNumber - 1) || null
        nextProduct.value = products.find((p) => p.colorNumber === product.colorNumber + 1) || null
      } catch (error) {
        console.error(error)
        reportSentry(error)
      }
    }
  },
)
</script>

<template>
  <img :src="product.image?.large" />
  <div v-if="needProducts" class="row justify-content-between mt-3">
    <div class="col-5">
      <div class="text-center">
        <b>{{ t("orderItem.prevSwatchColor") }}</b>
      </div>
      <img v-if="prevProduct" :src="prevProduct.image?.large" />
      <div v-else class="text-center mt-2">{{ t("shared.notExists") }}</div>
    </div>
    <div class="col-5">
      <div class="text-center">
        <b>{{ t("orderItem.nextSwatchColor") }}</b>
      </div>
      <img v-if="nextProduct" :src="nextProduct.image?.large" />
      <div v-else class="text-center mt-2">{{ t("shared.notExists") }}</div>
    </div>
  </div>
</template>

<style scoped>
img {
  width: 100%;
}
</style>
